import React from 'react'
import styles from './TextButton.module.scss'

type Props = {
  onClick: ()=> void;
  text: string;
  className?: string;
}

export const TextButton = ({onClick, text, className}: Props) => {
  return (
    <span onClick={onClick} className={[styles.TextButton, className? className : ""].join(" ")}>
      {text}
    </span>
  )
}
